/**
 * 로그아웃 시 로컬 상태 정리 유틸리티 함수들
 */

import { 
  TOKEN_KEY, 
  USER_KEY, 
  REFRESH_TOKEN_KEY, 
  ID_TOKEN_KEY 
} from './types';
import { clearAuthCookies } from './cookie-utils';
import type { ResolvedStorageKeys } from '../storage-keys';
import { resolveStorageKeys } from '../storage-keys';

/**
 * 전체 인증 상태 완전 정리 (로컬스토리지, 세션스토리지, 쿠키)
 */
export const performFullCleanup = (storageKeys?: Partial<ResolvedStorageKeys>): void => {
  console.log('[AuthUtils] 전체 인증 상태 정리 시작');
  const resolvedStorageKeys = resolveStorageKeys(storageKeys);
  
  // 1. 로컬 스토리지 완전 정리
  const authKeyPrefixes = ['edusense_', 'pearai_'];
  const authKeySuffixes = ['token', 'user', 'refresh_token', 'id_token', 'logout_state', 'token_endpoint_url'];
  const additionalKeys = [
    'auth_token',
    resolvedStorageKeys.tokenKey,
    resolvedStorageKeys.userKey,
    resolvedStorageKeys.refreshTokenKey,
    resolvedStorageKeys.idTokenKey,
    resolvedStorageKeys.tokenTypeKey,
    resolvedStorageKeys.tokenExpiresAtKey,
  ];
  
  authKeyPrefixes.forEach(prefix => {
    authKeySuffixes.forEach(suffix => {
      const key = prefix + suffix;
      localStorage.removeItem(key);
      console.log(`[AuthUtils] localStorage 키 삭제: ${key}`);
    });
  });
  
  additionalKeys.forEach(key => {
    localStorage.removeItem(key);
    console.log(`[AuthUtils] localStorage 키 삭제: ${key}`);
  });
  
  // 2. 세션 스토리지 정리
  const sessionKeys = sessionStorage.length;
  for (let i = sessionKeys - 1; i >= 0; i--) {
    const key = sessionStorage.key(i);
    if (key && (key.includes('auth') || key.includes('token') || key.includes('edusense'))) {
      sessionStorage.removeItem(key);
      console.log(`[AuthUtils] sessionStorage 키 삭제: ${key}`);
    }
  }
  
  // 3. 쿠키 정리
  clearAuthCookies();
  
  console.log('[AuthUtils] 전체 인증 상태 정리 완료');
};

/**
 * 기본 인증 토큰만 정리 (최소한의 정리)
 */
export const performMinimalCleanup = (storageKeys?: Partial<ResolvedStorageKeys>): void => {
  console.log('[AuthUtils] 최소한의 인증 상태 정리 시작');
  const resolvedStorageKeys = resolveStorageKeys(storageKeys);
  
  localStorage.removeItem(resolvedStorageKeys.tokenKey || TOKEN_KEY);
  localStorage.removeItem(resolvedStorageKeys.userKey || USER_KEY);
  localStorage.removeItem(resolvedStorageKeys.refreshTokenKey || REFRESH_TOKEN_KEY);
  localStorage.removeItem(resolvedStorageKeys.idTokenKey || ID_TOKEN_KEY);
  
  console.log('[AuthUtils] 최소한의 인증 상태 정리 완료');
};
